import Link from 'next/link';
import React, { FunctionComponent } from 'react';
type Props = {
  cta;
  children;
};

const SimpleLinkWrapper: FunctionComponent<Props> = ({ cta, children }) => {
  const url = cta?.route?.slug ? `/${cta.route.slug.current}` : cta.link;

  return <Link href={url} legacyBehavior>{children || 'no slug'}</Link>;
};

export default SimpleLinkWrapper;
